var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPetPark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PetPark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.005,
    height: 56.545,
    viewBox: "0 0 45.005 56.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 45.005,
    height: 56.545
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M44.693,19.365l-4.256-8.033A5.233,5.233,0,0,0,35.8,8.544H24.065V3.708a3.708,3.708,0,0,0-7.416,0V8.544H2.237A2.239,2.239,0,0,0,0,10.781v20a2.239,2.239,0,0,0,2.237,2.236H16.649V49.99H7.594a1.812,1.812,0,0,0-1.81,1.81v2.935a1.813,1.813,0,0,0,1.81,1.81H33.12a1.813,1.813,0,0,0,1.81-1.81V51.8a1.813,1.813,0,0,0-1.81-1.81H24.065V33.021h11.7a5.223,5.223,0,0,0,4.664-2.847l4.278-8.321a2.692,2.692,0,0,0-.016-2.488M18.961,3.708a1.4,1.4,0,0,1,2.792,0V8.544H18.961Zm4.6,48.595h9.055v1.932H8.1V52.3h9.055a1.813,1.813,0,0,0,1.81-1.81V33.021h2.792V50.492a1.812,1.812,0,0,0,1.81,1.81M42.652,20.8l-4.276,8.321a2.923,2.923,0,0,1-2.609,1.592H2.312V10.856H35.8a2.926,2.926,0,0,1,2.592,1.559l4.256,8.032a.376.376,0,0,1,0,.349",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M37.593,26.065a1.757,1.757,0,0,0,1.756-1.756v-.879a1.756,1.756,0,1,0-3.513,0v.879a1.757,1.757,0,0,0,1.756,1.756",
    transform: "translate(-15.124 -9.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M28.475,26.065a1.756,1.756,0,0,0,1.756-1.756v-.879a1.756,1.756,0,1,0-3.513,0v.879a1.757,1.757,0,0,0,1.756,1.756",
    transform: "translate(-11.276 -9.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M43.671,29.271a1.756,1.756,0,0,0-1.756,1.756v.879a1.756,1.756,0,0,0,3.513,0v-.879a1.757,1.757,0,0,0-1.756-1.756",
    transform: "translate(-17.689 -12.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M24.154,31.906v-.879a1.756,1.756,0,0,0-3.513,0v.879a1.756,1.756,0,0,0,3.513,0",
    transform: "translate(-8.711 -12.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M32.158,33.771h0a2.609,2.609,0,0,0-4.152,0l-3.192,4.194a2.609,2.609,0,0,0,2.076,4.188h6.383a2.608,2.608,0,0,0,2.076-4.187Z",
    transform: "translate(-10.247 -13.818)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetPark);
export default __webpack_public_path__ + "static/media/PetPark.b876ac7ac539207952a75fc855413a6d.svg";
export { ForwardRef as ReactComponent };